import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Yard'],
});
export const yardApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllYards: builder.query({
      query: () => `yards/`,
      providesTags: ['Yard'],
    }),
    findAllYardsWithLocation: builder.query({
      query: () => `yards/?location_master__isnull=False`,
      providesTags: ['Yard'],
    }),
    findAllYardsOfCluster: builder.query({
      query: (id) => `yards/?cluster=${id}`,
      providesTags: ['Yard'],
    }),
    findYardById: builder.query({
      query: (id) => `yards/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Yard', id: result.id }] : ['Yard'];
      },
    }),
    createYard: builder.mutation({
      query: (yard) => ({
        url: `yards/`,
        method: 'POST',
        body: yard,
      }),
      invalidatesTags: ['Yard'],
    }),
    updateYard: builder.mutation({
      query: (yard) => ({
        url: `yards/${yard.id}/`,
        method: 'PATCH',
        body: yard,
      }),
      invalidatesTags: ['Yard'],
    }),
    updateYardLocation: builder.mutation({
      query: ({ id, payload }) => ({
        url: `yards/${id}/insertLocation/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Yard'],
    }),
    deleteYard: builder.mutation({
      query: (yard) => ({
        url: `yards/${yard.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Yard'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllYardsQuery,
  useFindAllYardsWithLocationQuery,
  useFindYardByIdQuery,
  useCreateYardMutation,
  useUpdateYardMutation,
  useDeleteYardMutation,
} = yardApi;
